import { Injectable } from "@angular/core";

@Injectable()
export class SessionService {
  constructor() {}

  setData(data) {
    sessionStorage.setItem("loginUser", JSON.stringify(data));
  }
  getData() {
    return JSON.parse(sessionStorage.getItem("loginUser"));
  }
  setUsertoken(data) {
    sessionStorage.setItem("sbngbteng", data);
  }
  getUsertoken() {
    return sessionStorage.getItem("sbngbteng");
  }
  isData() {
    if (sessionStorage.getItem("loginUser")) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/session.service.ts